<template>
  <div class="terra-card">
    <div class="terra-card__header is-flex has-space-between is-marginless">
      <div class="sh-buttons-group" style="margin: 0 2rem 1rem;font-weight:500">
        <a class="mb-5 medium-weight is-blue is-semiBold-16-600-19" @click="is_create = !is_create">
          <span class="is-mr-5">
            <i class="fa fa-plus"></i>
          </span>
          {{localization('app-create-group','Create Group')}}
        </a>
        <span class="is-medium-16-500-19" style="color:#5c617e"> Or </span>
        <a @click="is_assign_group = true" class="sh-button medium-weight is-blue is-semiBold-16-600-19">{{localization('app-assign-group','Assign Group')}}</a>
      </div>
      <AssignGroup
        v-click-outside="() => (is_assign_group = false)"
        @close="is_assign_group = false"
        @groups_added="getData"
        v-if="is_assign_group"
        :details="details"
      />
    </div>
    <div class="terra-card__body">
      <div class="terra-card__body--card">
        <div class="list-card" v-if="is_create">
          <div class="list-card__header" style="align-items: center;">
            <input
              @keyup.enter="save"
              @keyup.esc="is_create = false"
              v-model="form.name"
              type="text"
              class="input no-outline is-medium-16-500-19"
              :placeholder="localization('app-feature-type-group-name', 'Feature Type Group Name')"
            />
            <div @click="save" style="margin-left:10px; color:#5c7ef7; cursor:pointer">
              <i class="fa fa-check"></i>
            </div>
          </div>
        </div>
        <FeatureTypeGroup @feature_type_added="getData" v-for="group in sort(data)" :group="group" :key="group.uid" />
      </div>
    </div>
  </div>
</template>

<script>
import FeatureTypeGroup from "./component/feature-type-group";
import AssignGroup from "./component/assign-group-dropdown.vue";
import FeatureTypeGroupService from "@/services/feature-type-group.service";
const featureTypeGroupService = new FeatureTypeGroupService();
import { mapState } from "vuex";
export default {
  components: {
    FeatureTypeGroup,
    AssignGroup,
  },
  props: ["details"],
  data() {
    return {
      data: [],
      is_create: false,
      is_assign_group: false,
      form: { name: "" },
      active: false,
    };
  },
  async created() {
    this.getData();
  },
  computed: {
    ...mapState(["container"]),
  },
  methods: {
    sort(data) {
      if (data && data.length) return _.sortBy(data, ["name"]);
      return [];
    },
    async getData() {
      try {
        this.data = (await featureTypeGroupService.get_ftg({
          id: this.$route.params.uid,
        })).data;
      } catch (err) {
        this.handleErrors(err);
      }
    },
    async save() {
      if (!this.form.name) {
        this.$toast.open("Name is Required");
        return;
      }
      if (this.is_create) {
        this.is_create = false;
        try {
          let data = (await featureTypeGroupService.post({
            body: { name: this.form.name, org: this.container.organization },
          })).data;
          this.form.name = "";
          this.assign_ftg(data.uid);
        } catch (err) {
          this.handleErrors(err);
        }
      }
    },
    async assign_ftg(uid) {
      try {
        await featureTypeGroupService.assign_to_view({
          id: this.$route.params.uid,
          body: {
            featureTypeGroups: [uid],
          },
        });
        this.getData();
      } catch (err) {
        this.handleErrors(err);
      }
    },
  },
};
</script>
<style lang="scss">
.input.no-outline {
  &:focus,
  &:active {
    box-shadow: none;
  }
}
.terra-card {
  position: relative;
  &__header {
    font-weight: 600;
    margin-bottom: 2rem;
  }
  &__body {
    padding: 0 2rem;
    &--card {
      border-radius: 0.5rem;
      border: none;
      .list-card {
        background: #fff;
        margin-bottom: 10px;
        border: none;
        border-radius: 0.5rem;
        box-shadow: 0 3px 6px 0 rgba(92, 126, 247, 0.3);
        &__header {
          display: flex;
          justify-content: space-between;
          padding: 1rem;
          border-bottom: 1px solid #eee;
          &--text {
            font-weight: 600;
          }
        }
        &__body {
          &--item {
            padding: 6px 1rem;
            display: flex;
            justify-content: space-between;
            &-text {
              font-weight: 500;
            }
          }
        }
      }
    }
  }
}
</style>
